import React, { useState } from "react";
import Navbar from "../components/Navbar";
import styles from "./Writing.module.css";
import { useMoralis } from "react-moralis";

import { useQuill } from "react-quilljs";
// or const { useQuill } = require('react-quilljs');

import "quill/dist/quill.snow.css"; // Add css for snow theme
import { mintNFT } from "../actions/mintNFT";
// or import 'quill/dist/quill.bubble.css'; // Add css for bubble theme

function Writing() {
  const { quill, quillRef } = useQuill();
  let count = 0;
  const [reward, ShowReward] = useState(false);

  const { authenticate, isAuthenticated, user } = useMoralis();

  console.log(quill); // undefined > Quill Object
  console.log(quillRef); // { current: undefined } > { current: Quill Editor Reference }

  const mint = () => {
    alert(
      "Congrats ! A mon NFT will be soon minted and sent to your eth address : " +
        user.get("ethAddress")
    );
  };

  React.useEffect(() => {
    if (quill) {
      quill.on("text-change", (delta, oldDelta, source) => {
        console.log(quill.getText().length); // Get text only
        if (quill.getText().length > 25) {
          ShowReward(true);
        }
      });
    }
  }, [quill]);

  return (
    <div>
      <Navbar />

      <div style={{ width: 2000, height: 400 }}>
        <div ref={quillRef} />
      </div>

      <div className={styles.encounters}>
        <h4 className={styles["title"]}>Encounters</h4>
        {reward && (
          <button className={styles.bu} onClick={mint}>
            Claim Reward
          </button>
        )}

        <button className={styles.button2} onClick={mint}>
          Save
        </button>
      </div>
    </div>
  );
}

export default Writing;
